import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEnvelopeClosed = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EnvelopeClosed</title>
    <path
      d="M5.943 7.854H26.06c1.383 0 2.515 1.03 2.515 2.286v13.716c0 1.257-1.132 2.286-2.515 2.286H5.943c-1.383 0-2.514-1.029-2.514-2.286V10.14c0-1.257 1.131-2.286 2.514-2.286Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M28.574 8.996 16.002 18.14 3.429 8.996" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
  </svg>
);
export default SvgIcoEnvelopeClosed;
